export enum ReviewType {
	AUDIT = 'AUDIT',
	OPINION = 'OPINION',
	RATING = 'RATING',
	VERIFICATION = 'VERIFICATION',
	CERTIFICATION = 'CERTIFICATION',
	ICMA_EXTERNAL_REVIEW_FORM = 'ICMA_EXTERNAL_REVIEW_FORM',
	FACTSHEET_CBI = 'FACTSHEET_CBI',
}